import React from 'react'
import { FiClock } from 'react-icons/fi'
import {BiCoffeeTogo} from 'react-icons/bi'
import {IoMdFingerPrint} from 'react-icons/io' 

export const advantages = [
{img:'typescript', title:'Typescript'},
{img:'sass', title:'Sass'},
{img:'bootstrap', title:'Bootstrap'},
{img:'redux', title:'Redux Toolkit'},
{img:'framer-motion', title:'Framer Motion'},
]
export const coreFeatures = [
{img:'redux', title:'Redux'},
{img:'react', title:'React'},
{img:'bootstrap', title:'Bootstrap'},
{img:'typescript', title:'Typescript'},
{img:'sass', title:'Sass'},
{img:'html', title:'HTML5'},
{img:'css', title:'CSS3'},
{img:'framer-motion', title:'Framer Motion'},
// {symbol:<FiMoon />, title:'Darkmode'},
// {symbol:<VscWorkspaceTrusted />, title:'W3'},
// {symbol:<FiSmartphone />, title:'Mobile Copatible & Cross platform'},
// {symbol:<FiLayout />, title:'Well Documented'},
]
export const drawersScreens = [
{id:'#', index:1,path:'/drawer-users1', name:'Users Drawer'},
{id:'#', index:2,path:'/drawer-profile1', name:'Profile Drawer'},
{id:'#', index:3,path:'/drawer-profile-2', name:'Profile Drawer 2'},
{id:'#', index:4,path:'/drawer-user', name:'User Drawer'},
{id:'#', index:5,path:'/modal-feature1', name:'Modal Feature'},
]
export const examples = [
{index:0,path:'/landing/home', name:'Homepage'},
{index:1,path:'/category', name:'Category'},
{index:'1.1',path:'/category', name:'Category 2'},
{index:2,path:'/projects/filter', name:'Projects'},
{index:'projects',path:'/projects/filter', name:'Projects Filter'},
{index:3,path:'/profile', name:'Profile'},
{index:4,path:'/projects', name:'Project Show Page'},  
{index:5,path:'/account/favorites', name:'Favorites'},

{index:6,path:'/projects/filter', name:'Projects'},
{index:7,path:'/account', name:'Account'},
{index:8,path:'/projects/filter', name:'Projects'},
{index:9,path:'/notifications', name:'Notifications'},
{index:10,path:'/account/notification', name:'Account Settings'},
{index:11,path:'/account/friendship', name:'Account Friendship'},
{index:12,path:'/account/requests', name:'Account Requests'},
{index:19,path:'/users', name:'Search'},
{index:13,path:'/projects#search', name:'Search'},
{index:14,path:'/signup', name:'Sign up'},
{index:15,path:'/signin', name:'Sign in'},
{index:16,path:'/account/change', name:'Change Password'},
{index:'home-remote',path:'#', name:'Remote Job (soon)'},
{index:17, name:'NFT Marketplace (soon)'},
{index:18, name:'Crypto (soon)'},
]
 
export const faq = [
    {title:'Fast',  path:'#',symbol:<FiClock /> , description:'Fastest template built with React and powered by NextJS. Build your amazing React App with NOVA.'}, 
    {title:'Easy to use', path:'#',symbol:<BiCoffeeTogo />, description:'Easy to use with advanced and rich components. High customization & hybrid features adaptable for different environments.'}, 
    {title:'Unique', path:'#',symbol:<IoMdFingerPrint /> , description:'Lots of creative, remarkable adn greate landing, home and inner pages with their wonderful fascinating components'}, 
]
export const formScreens = [
    {id:'/account/setting', index:1,path:'/form-1', name:'Account Form Page'},
    {id:'/profiles/create', index:2,path:'/form-2', name:'Profile Create Page'},
    {id:'/contact', index:3,path:'/contact', name:'Contact Page'},
    {id:'/faq', index:4,path:'/faq', name:'FAQ Page'},
    {id:'/about', index:5,path:'/about', name:'About Page'},
]
export const headers = [
    {index:'header-3',path:'/#', name:'Header One'},
    {index:'header-auth',path:'/#', name:'Header Two Guest'},
    {index:'header-guest',path:'/#', name:'Header Two Auth'},
    {index:'header-2',path:'/#', name:'Header Three'},
]
export const homeScreens = [
    {index:1,id:'/landing/pink',path:'/home-1', name:'Pink Hero Section'},
    {index:2,id:'/landing/green',path:'/home-2', name:'Green Hero Section'},
    {index:3,id:'/landing/header',path:'/home-3', name:'Image Hero Section'},
]
export const landingScreens = [
    {id:'/landing/job',index:1,path:'/landing-1', name:'Landing Page 1'},
    {id:'/landing/listing',index:2,path:'/landing-2', name:'Landing Page 2'},
    {id:'/landing/green', index:7,path:'/green-home', name:'Landing Page 2'},
]
export const nextScreens = [
    {id:'#',index:1,path:'/home-hotel', name:'Listing Directory'},
    {id:'#',index:2,path:'/home-nft', name:'NFT'},
]
export const uiScreens = [
    {id:'/projects/create', index:6,path:'/project-create', name:'Project Create Page'},
    {id:'#', index:8,path:'/home-dark', name:'Home Dark Page (soon)'},
]
export const socialScreens = [
    {id:'/profiles/feed', index:0,path:'/profile1', name:'Grid 3'},
    {id:'/profiles/grid', index:1,path:'/profile2', name:'Grid 3'},
    {id:'/profile', index:3,path:'/profile3', name:'Grid 2'},
]
export const socialPages = [
    {id:'/profiles/feed',index:0,path:'/profile4', name:'Profile 1'},
    {id:'/profiles/grid',index:1,path:'/profile5', name:'Profile 2'},
    { name:'Profile 3 (soon)'},
]
